module.exports = __webpack_public_path__ + "static/media/footer-ico2.bacac1ff.svg";